/**
 * Constantes liées aux inscriptions
 * Source de vérité unique — miroir du schéma Prisma
 */

export const InscriptionStatut = {
  DEMANDE: 'DEMANDE',
  DEVIS_ENVOYE: 'DEVIS_ENVOYE',
  DEVIS_SIGNE: 'DEVIS_SIGNE',
  ORGANISATION_FORMATION: 'ORGANISATION_FORMATION',
  EN_ATTENTE_DISPO: 'EN_ATTENTE_DISPO',
  NON_DISPONIBLE: 'NON_DISPONIBLE',
  EN_ATTENTE_INSCRIPTION: 'EN_ATTENTE_INSCRIPTION',
  EN_ATTENTE_PAIEMENT: 'EN_ATTENTE_PAIEMENT',
  INSCRIT: 'INSCRIT',
  EN_ATTENTE_CONVENTION_PRESTATAIRE: 'EN_ATTENTE_CONVENTION_PRESTATAIRE',
  CONVENTION_SIGNEE: 'CONVENTION_SIGNEE',
  INSCRIPTION_VALIDEE_EN_ATTENTE_DEROULEMENT: 'INSCRIPTION_VALIDEE_EN_ATTENTE_DEROULEMENT',
  FORMATION_TERMINEE: 'FORMATION_TERMINEE',
  EN_ATTENTE_PAIEMENT_PRO: 'EN_ATTENTE_PAIEMENT_PRO',
  CLOTURE: 'CLOTURE',
  PERDU: 'PERDU',
  ANNULE: 'ANNULE',
  CORBEILLE: 'CORBEILLE',
  EN_ATTENTE_FINALISATION_CLIENT: 'EN_ATTENTE_FINALISATION_CLIENT',
  EN_ATTENTE_STAGIAIRES_CLIENT: 'EN_ATTENTE_STAGIAIRES_CLIENT',
  EN_ATTENTE_SIGNATURE_CLIENT: 'EN_ATTENTE_SIGNATURE_CLIENT',
  FORMATION_TERMINEE_EN_ATTENTE_REGLEMENT: 'FORMATION_TERMINEE_EN_ATTENTE_REGLEMENT',
  DOSSIER_CLOTURE: 'DOSSIER_CLOTURE',
}

export const INSCRIPTION_STATUT_LABELS = {
  [InscriptionStatut.DEMANDE]: 'Demande',
  [InscriptionStatut.DEVIS_ENVOYE]: 'Devis envoyé',
  [InscriptionStatut.DEVIS_SIGNE]: 'Devis signé',
  [InscriptionStatut.ORGANISATION_FORMATION]: 'Organisation formation',
  [InscriptionStatut.EN_ATTENTE_DISPO]: 'En attente dispo',
  [InscriptionStatut.NON_DISPONIBLE]: 'Non disponible',
  [InscriptionStatut.EN_ATTENTE_INSCRIPTION]: 'En attente inscription',
  [InscriptionStatut.EN_ATTENTE_PAIEMENT]: 'En attente paiement',
  [InscriptionStatut.INSCRIT]: 'Inscrit',
  [InscriptionStatut.EN_ATTENTE_CONVENTION_PRESTATAIRE]: 'Attente convention',
  [InscriptionStatut.CONVENTION_SIGNEE]: 'Convention signée',
  [InscriptionStatut.INSCRIPTION_VALIDEE_EN_ATTENTE_DEROULEMENT]: 'Validée — en attente',
  [InscriptionStatut.FORMATION_TERMINEE]: 'Formation terminée',
  [InscriptionStatut.EN_ATTENTE_PAIEMENT_PRO]: 'Attente paiement pro',
  [InscriptionStatut.CLOTURE]: 'Clôturé',
  [InscriptionStatut.PERDU]: 'Perdu',
  [InscriptionStatut.ANNULE]: 'Annulé',
  [InscriptionStatut.CORBEILLE]: 'Corbeille',
  [InscriptionStatut.EN_ATTENTE_FINALISATION_CLIENT]: 'Attente finalisation',
  [InscriptionStatut.EN_ATTENTE_STAGIAIRES_CLIENT]: 'Attente stagiaires',
  [InscriptionStatut.EN_ATTENTE_SIGNATURE_CLIENT]: 'Attente signature',
  [InscriptionStatut.FORMATION_TERMINEE_EN_ATTENTE_REGLEMENT]: 'Attente règlement',
  [InscriptionStatut.DOSSIER_CLOTURE]: 'Dossier clôturé',
}

export const INSCRIPTION_STATUT_OPTIONS = Object.entries(INSCRIPTION_STATUT_LABELS).map(
  ([value, label]) => ({ value, label })
)

const BADGE_COLORS = {
  DEMANDE:                                   { bg: '#e0e7ff', color: '#3730a3', border: '#6366f1' },
  DEVIS_ENVOYE:                              { bg: '#f3f4f6', color: '#374151', border: '#d1d5db' },
  DEVIS_SIGNE:                               { bg: '#dbeafe', color: '#1e40af', border: '#3b82f6' },
  ORGANISATION_FORMATION:                    { bg: '#ede9fe', color: '#5b21b6', border: '#8b5cf6' },
  EN_ATTENTE_DISPO:                          { bg: '#fef3c7', color: '#92400e', border: '#f59e0b' },
  NON_DISPONIBLE:                            { bg: '#fee2e2', color: '#991b1b', border: '#ef4444' },
  EN_ATTENTE_INSCRIPTION:                    { bg: '#fef3c7', color: '#92400e', border: '#f59e0b' },
  EN_ATTENTE_PAIEMENT:                       { bg: '#fef3c7', color: '#92400e', border: '#f59e0b' },
  INSCRIT:                                   { bg: '#d1fae5', color: '#065f46', border: '#10b981' },
  EN_ATTENTE_CONVENTION_PRESTATAIRE:         { bg: '#fef3c7', color: '#92400e', border: '#f59e0b' },
  CONVENTION_SIGNEE:                         { bg: '#d1fae5', color: '#065f46', border: '#10b981' },
  INSCRIPTION_VALIDEE_EN_ATTENTE_DEROULEMENT:{ bg: '#dcfce7', color: '#14532d', border: '#22c55e' },
  FORMATION_TERMINEE:                        { bg: '#dbeafe', color: '#1e40af', border: '#3b82f6' },
  EN_ATTENTE_PAIEMENT_PRO:                   { bg: '#fef3c7', color: '#92400e', border: '#f59e0b' },
  CLOTURE:                                   { bg: '#166534', color: '#f0fdf4', border: '#15803d' },
  PERDU:                                     { bg: '#7f1d1d', color: '#fef2f2', border: '#b91c1c' },
  ANNULE:                                    { bg: '#374151', color: '#f9fafb', border: '#6b7280' },
  CORBEILLE:                                 { bg: '#1f2937', color: '#f9fafb', border: '#4b5563' },
  EN_ATTENTE_FINALISATION_CLIENT:            { bg: '#fef3c7', color: '#92400e', border: '#f59e0b' },
  EN_ATTENTE_STAGIAIRES_CLIENT:             { bg: '#fef3c7', color: '#92400e', border: '#f59e0b' },
  EN_ATTENTE_SIGNATURE_CLIENT:              { bg: '#fef3c7', color: '#92400e', border: '#f59e0b' },
  FORMATION_TERMINEE_EN_ATTENTE_REGLEMENT:   { bg: '#dbeafe', color: '#1e40af', border: '#3b82f6' },
  DOSSIER_CLOTURE:                           { bg: '#166534', color: '#f0fdf4', border: '#15803d' },
}

// Merge labels from INSCRIPTION_STATUT_LABELS into badge config (single source of truth)
export const INSCRIPTION_STATUT_BADGE_CONFIG = Object.fromEntries(
  Object.entries(BADGE_COLORS).map(([key, colors]) => [
    key,
    { label: INSCRIPTION_STATUT_LABELS[key] || key, ...colors },
  ])
)

export const ClientType = {
  PARTICULIER: 'particulier',
  PROFESSIONNEL: 'professionnel',
}

export const CLIENT_TYPE_LABELS = {
  [ClientType.PARTICULIER]: 'Particulier',
  [ClientType.PROFESSIONNEL]: 'Professionnel',
}

export const CLIENT_TYPE_OPTIONS = [
  { value: '', label: 'Tous types client' },
  ...Object.entries(CLIENT_TYPE_LABELS).map(([value, label]) => ({ value, label })),
]

export const SourceInscription = {
  PRESTATAIRE_EXTERNE: 'prestataire_externe',
  NOTRE_ORGANISME: 'notre_organisme',
}

export const SOURCE_INSCRIPTION_LABELS = {
  [SourceInscription.PRESTATAIRE_EXTERNE]: 'Prestataire externe',
  [SourceInscription.NOTRE_ORGANISME]: 'Notre organisme',
}

export const SOURCE_INSCRIPTION_OPTIONS = [
  { value: '', label: 'Toutes sources' },
  ...Object.entries(SOURCE_INSCRIPTION_LABELS).map(([value, label]) => ({ value, label })),
]

// Reverse map: statut → group key + config
const STATUT_TO_GROUP = {}

export function getInscriptionStatusGroup(statut) {
  const groupKey = STATUT_TO_GROUP[statut]
  if (!groupKey) return null
  return { key: groupKey, ...INSCRIPTION_STATUS_GROUPS[groupKey] }
}

export const INSCRIPTION_STATUS_GROUPS = {
  DEMANDE: {
    label: 'Demande',
    statuts: ['DEMANDE', 'DEVIS_ENVOYE', 'EN_ATTENTE_DISPO', 'NON_DISPONIBLE'],
    bg: '#e0e7ff', color: '#3730a3', border: '#6366f1',
  },
  EN_COURS: {
    label: 'En cours',
    statuts: ['EN_ATTENTE_INSCRIPTION', 'EN_ATTENTE_FINALISATION_CLIENT', 'EN_ATTENTE_STAGIAIRES_CLIENT', 'EN_ATTENTE_SIGNATURE_CLIENT', 'EN_ATTENTE_PAIEMENT', 'DEVIS_SIGNE', 'ORGANISATION_FORMATION'],
    bg: '#fef3c7', color: '#92400e', border: '#f59e0b',
  },
  VALIDE: {
    label: 'Validé',
    statuts: ['INSCRIT', 'INSCRIPTION_VALIDEE_EN_ATTENTE_DEROULEMENT', 'CONVENTION_SIGNEE', 'EN_ATTENTE_CONVENTION_PRESTATAIRE', 'FORMATION_TERMINEE', 'EN_ATTENTE_PAIEMENT_PRO', 'CLOTURE', 'FORMATION_TERMINEE_EN_ATTENTE_REGLEMENT', 'DOSSIER_CLOTURE'],
    bg: '#d1fae5', color: '#065f46', border: '#10b981',
  },
  PERDU: {
    label: 'Perdu',
    statuts: ['PERDU', 'ANNULE', 'CORBEILLE'],
    bg: '#fee2e2', color: '#991b1b', border: '#ef4444',
  },
}

// Populate reverse map after INSCRIPTION_STATUS_GROUPS is defined
for (const [groupKey, group] of Object.entries(INSCRIPTION_STATUS_GROUPS)) {
  for (const statut of group.statuts) {
    STATUT_TO_GROUP[statut] = groupKey
  }
}
